import {
  Button,
  Checkbox,
  Col,
  Input,
  notification,
  Popconfirm,
  Row,
  Skeleton,
  Space,
  Statistic,
  Switch,
  Table,
} from "antd";
import { useContext, useEffect, useRef, useState } from "react";
import { ContentBox } from "../../../components/layout/content";
import { LoginedLayout } from "../../../components/layout/loginLayout";
import { UserContext } from "../../../context/userContext";
import { ItemSku } from "../../../Data/data_item"; // Import your mock data here
import { regexBarcode } from "../../../functions/regexBarcode";
import { GET, GETV2, POST } from "../../../services";
import {
  CHECKER_CONFIRM_NO_ITEM,
  CHECKER_CONFIRM_PICK,
  CHECKER_GET_PICK_SKU,
  CHECKER_GET_STAT,
  CHECKER_LOCKED_BATCH,
  CHECKER_NO_ITEM,
  CHECKER_UNLOCK_BATCH,
  CHECKER_VALIDATE_BATCH,
} from "../../../services/path";
import "../pick/style.css"; // Adjust the path to match your directory structure
import NoItemModal from "../pick/view/noItemModal";
import OtpModal from "../pick/view/otpModal";
import WarningModal from "../pick/view/warningModal";

interface ErrorData {
  isError: boolean;
  reason: string;
}

const PickFocus = () => {
  const columns = [
    {
      title: "SKU",
      dataIndex: "sku",
      key: "sku",
      render: (text: string) => (
        <div>
          <span style={{ marginLeft: 8 }}>{text}</span>
        </div>
      ),
    },
    {
      title: "QTY",
      dataIndex: "show_qty",
      key: "show_qty",
      render: (text: number) => (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <span style={{ marginLeft: 8 }}>{text}</span>
        </div>
      ),
    },
    {
      title: "ไม่มีของ",
      dataIndex: "status",
      key: "status",
      render: (_: string, record: any) => {
        const { sku, isFull, isChecked } = record;
        if (isFull || isConfirmNoItem) {
          return null; // Don't render checkbox for rows where isFull is true
        } else {
          return <Checkbox checked={isChecked} onChange={(e) => handleCheckboxChange(sku)} />;
        }
      },
    },
  ];

  // State variables
  const [totalOrder, setTotalOrder] = useState("0");
  const [targetOrder, setTargetOrder] = useState("0");
  const [averageTime, setAverageTime] = useState("0");
  const [targetAverageTime, setTargetAverageTime] = useState("0");
  const [isTimeGood, setIsTimeGood] = useState(false);
  const [isAchieved, setIsAchieved] = useState(false);
  const [batchID, setBatchID] = useState("");
  const [skuID, setSKU] = useState("");
  const [data, setData] = useState<ItemSku[]>(JSON.parse(localStorage.getItem("skuData") || "[]"));
  const [incorrectAttempts, setIncorrectAttempts] = useState(0);
  const [errorData, setErrorData] = useState<ErrorData>({ isError: false, reason: "test" });
  const [isConfirmNoItem, setConfirmNoItem] = useState<boolean>(
    localStorage.getItem("isConfirmNoItem") === "true",
  );

  const { user } = useContext(UserContext);
  const [isOtpModalVisible, setIsOtpModalVisible] = useState(false);
  const [isWarningModalVisible, setIsWarningModalVisible] = useState(false);
  const [isnoItemModalVisible, setIsNoItemModalVisible] = useState(false);
  const [isloading, setIsloading] = useState(false);
  const [isloadingSubmit, setIsloadingSubmit] = useState(false);
  const [isloadingNoItem, setIsloadingNoItem] = useState(false);
  const [batchNoScanned, setBatchNoScanned] = useState(false);
  const [isSwitchOn, setIsSwitchOn] = useState(false);
  const skuInputRef = useRef<any>(null);
  const rowKey = (record: any) => record.sku;
  const handleBatchEntered = async (batchID: string) => {
    if (!batchID.trim()) {
      notification.warning({
        message: "Batch Empty",
        description: "กรุณาใส่เลข Batch",
        duration: 3, // Duration the notification stays open
      });

      return; // Exit the function early
    }

    setIsloading(true);
    try {
      const batchCheckResponse = await POST(CHECKER_VALIDATE_BATCH, {
        batch_id: batchID,
        brand: "focus",
      });

      const { Result, Locked, RefOTP } = batchCheckResponse;

      // Case : Default
      if (Result && !Locked) {
        const batch_id = batchID;
        const brand = "focus";
        const itemsResponse = await GET(CHECKER_GET_PICK_SKU(batch_id, brand));

        //Sub Case : Default
        if (itemsResponse && itemsResponse.length > 0) {
          skuInputRef.current?.focus();
          setData(itemsResponse);
          setBatchNoScanned(true);

          //Sub Case : Bathc ถูก Pick แล้ว
        } else if (itemsResponse && itemsResponse.length === 0) {
          notification.warning({
            message: "Notification",
            description: "Batch นี้ถูก pick แล้ว",
          });
        } else {
          setIsWarningModalVisible(true);
        }

        //Case : Locked No_Item
      } else if (Result && Locked && RefOTP === null) {
        setIsNoItemModalVisible(true);

        //Case : Locked OTP
      } else if (Result && Locked && RefOTP !== "") {
        setIsOtpModalVisible(true);
        localStorage.setItem("batchID", batchID);
        localStorage.setItem("ref_otp", RefOTP);
      }
    } catch (error) {
      console.error("Failed to fetch batch data:", error);
      setIsWarningModalVisible(true);
    } finally {
      setIsloading(false);
    }
  };

  const lockBatch = async (batchID: string) => {
    try {
      if (user && user.user_id && user.username) {
        const response = await POST(CHECKER_LOCKED_BATCH, {
          batch_id: batchID,
          user_req_id: user.user_id,
          username: user.username,
          brand: "focus",
          reason: errorData.reason,
        });

        if (response) {
          localStorage.setItem("ref_otp", response);
        } else {
          return { success: false, error: response.error };
        }
      } else {
        return { success: false, error: "Invalid user context data" };
      }
    } catch (error) {
      console.error("Error locking the batch:", error);
    }
  };

  useEffect(() => {
    if (errorData.isError) {
      lockBatch(batchID);
      setIsOtpModalVisible(true);
    }
  }, [errorData, batchID]);

  // Handle SKU input change
  const handleSKUInputChange = (barcode: string) => {
    localStorage.setItem("batchID", batchID);
    let formattedBarcode: string;
    if (barcode.startsWith("n=")) {
      formattedBarcode = regexBarcode(barcode);
    } else if (!isNaN(Number(barcode))) {
      const itemWithBarcode = data.find((item) => item.barcode === barcode);
      formattedBarcode = itemWithBarcode ? itemWithBarcode.sku : barcode;
    } else {
      formattedBarcode = regexBarcode(barcode);
    }
    if (formattedBarcode.trim() !== "") {
      const matchingItem = data.find(
        (item) =>
          item.sku === formattedBarcode ||
          (formattedBarcode.includes("HYDRO") && item.barcode.includes(formattedBarcode)),
      );

      if (matchingItem) {
        if (matchingItem.isChecked) {
          setIncorrectAttempts((prevAttempts) => prevAttempts + 1);
          if (incorrectAttempts + 1 > 2) {
            setErrorData({
              isError: true,
              reason: "ทำผิด : ใส่ SKU ที่ถูกติ๊กแล้วเกิน 2 ครั้ง",
            });
            setIsOtpModalVisible(true);
          }
        } else {
          // หากพบ SKU ในข้อมูล
          const currentQuantity = matchingItem.qty || 0;
          const newQuantity = currentQuantity + 1;

          // Case ErrTye 2 : ตรวจสอบว่าปริมาณใหม่เกินปริมาณทั้งหมดสำหรับ SKU หรือไม่
          if (newQuantity > matchingItem.total_qty) {
            setIncorrectAttempts((prevAttempts) => prevAttempts + 1);
            if (incorrectAttempts + 3 > 2) {
              setErrorData({
                isError: true,
                reason: "ทำผิด : ใส่ SKU เกินจำนวนและถูกล็อค",
              });
              setIsOtpModalVisible(true);
            }

            //Case : Defaults
          } else {
            const updatedSkuQuantities = { ...data, [formattedBarcode]: newQuantity };
            setData(updatedSkuQuantities);
            localStorage.setItem("skuData", JSON.stringify(updatedSkuQuantities));
            const updatedSkuData = data.map((item) =>
              item.sku === formattedBarcode ||
              (formattedBarcode.includes("HYDRO") && item.barcode.includes(formattedBarcode))
                ? {
                    ...item,
                    qty: newQuantity,
                    isFull: newQuantity === matchingItem.total_qty,
                    isChecked: item.isChecked,
                    total_qty: matchingItem.total_qty,
                    barcode: matchingItem.barcode,
                    alter_sku: matchingItem.alter_sku,
                  }
                : item,
            );

            setData(updatedSkuData);
            localStorage.setItem("skuData", JSON.stringify(updatedSkuData));
          }
        }

        // Case ErrTye 3 : หากไม่พบ SKU ในข้อมูล
      } else {
        setIncorrectAttempts((prevAttempts) => prevAttempts + 1);
        if (incorrectAttempts + 1 > 2) {
          setErrorData({
            isError: true,
            reason: "ทำผิด : ใส่ SKU ที่ไม่มีในแบทช์",
          });

          setIsOtpModalVisible(true);
        }
      }
    } else {
      // หากข้อมูล SKU ว่าง, แสดงโมดัลคำเตือน
      setIsWarningModalVisible(true);
    }

    // ล้างข้อมูลนำเข้า SKU หลังจากการประมวลผล
    setSKU("");
  };

  // Call back Current State
  useEffect(() => {
    const storedBatchID = localStorage.getItem("batchID");
    const storedSkuData = JSON.parse(localStorage.getItem("skuData") || "[]");
    const loadData = async () => {
      if (storedBatchID) {
        setBatchID(storedBatchID);
        if (Object.keys(storedSkuData).length === 0) {
          await handleBatchEntered(storedBatchID);
        } else {
          await handleBatchEntered(storedBatchID);
          setData(storedSkuData);
        }
      }
    };

    handleGetStat();
    loadData();
  }, []);

  const handleReset = () => {
    localStorage.clear();
    window.location.reload();
  };

  const handleGetStat = async () => {
    try {
      const response = await GETV2(CHECKER_GET_STAT("picked"));
      setTotalOrder(response?.result?.total_order ?? 0);
      setAverageTime(response?.result?.average_time ?? 0);
      setTargetOrder(response?.result?.target_order ?? 0);
      setTargetAverageTime(response?.result?.target_average_time ?? 0);
      setIsAchieved(
        Number(response?.result?.total_order) >= Number(response?.result?.target_order),
      );
      setIsTimeGood(
        Number(response?.result?.average_time) <= Number(response?.result?.target_average_time),
      );
    } catch (error: any) {
      notification.error({
        message: "Error",
        description: error?.message ?? "Get stat fail!",
      });
    }
  };

  //ยืนยัน OTP ปลดล็อค Batch
  const handleOtpSubmit = async (otp: string, userID: string) => {
    try {
      // ดึงข้อมูล Batch ID และผู้ใช้งานจาก local storage
      const storedBatchID = localStorage.getItem("batchID");
      const storedRefOtp = localStorage.getItem("ref_otp");

      // ตรวจสอบว่า Batch ID และชื่อผู้ใช้งานถูกต้องหรือไม่
      if (storedBatchID && storedRefOtp) {
        // ส่งค่า OTP ไปที่ API เพื่อปลดล็อค Batch
        if (storedBatchID && storedRefOtp) {
          const unlockBatchResponse = await POST(CHECKER_UNLOCK_BATCH, {
            batch_id: storedBatchID,
            otp: otp,
            ref_otp: storedRefOtp,
            user_admin_id: userID,
          });

          if (unlockBatchResponse) {
            if (
              typeof unlockBatchResponse === "string" &&
              unlockBatchResponse.includes("invalid otp or batch id")
            ) {
              notification.error({
                message: "Error",
                description: "Failed to unlock batch. Please try again.",
              });
            } else {
              setIsOtpModalVisible(false);
              setIncorrectAttempts(0);
              localStorage.removeItem("ref_otp");
              localStorage.removeItem("errorReason");
              localStorage.removeItem("skuData");
              notification.success({
                message: "Success",
                description: "Batch unlocked successfully!",
              });
            }

            window.location.reload();
          }
        } else {
          notification.error({
            message: "error",
            description: "Batch unlocked fail!",
          });
        }
      }
    } catch (error) {
      console.error("Failed to unlock batch:", error);
      notification.error({
        message: "Error",
        description: "An error occurred while unlocking batch. Please try again.",
      });
    }
  };

  const handleCheckboxChange = (sku: string) => {
    localStorage.setItem("batchID", batchID);
    const updatedSkuData = data.map((item) => {
      if (item.sku === sku) {
        return {
          ...item,
          isChecked: !item.isChecked,
          isFull: false,
          qty: item.qty ? item.qty : 0,
        };
      }

      return item;
    });

    setData(updatedSkuData);
    localStorage.setItem("skuData", JSON.stringify(updatedSkuData));
  };

  const handleNoItem = async () => {
    setIsloadingNoItem(true);
    try {
      const storedBatchID = localStorage.getItem("batchID");
      const storedCheckedItems = localStorage.getItem("skuData");
      const checkedItems = storedCheckedItems ? JSON.parse(storedCheckedItems) : [];
      const response = await POST(CHECKER_NO_ITEM, {
        user_req_id: user.user_id,
        username: user.username,
        batch_id: storedBatchID,
        item: checkedItems.map((item: { sku: string; qty: number; total_qty: number }) => ({
          sku: item.sku,
          qty: item.qty,
          total_qty: item.total_qty,
        })),
        brand: " focus",
      });

      if (response) {
        localStorage.setItem("ref_otp", response);
        setIsNoItemModalVisible(true);
      } else {
        console.error("Failed to call CHECKER_NO_ITEM API:", response.error);
        setIsloadingNoItem(false);
      }
    } catch (error) {
      console.error("Error calling CHECKER_NO_ITEM API:", error);
      notification.error({
        message: "Error",
        description: "An error occurred while unlocking batch. Please try again.",
      });

      setIsloadingNoItem(false);
    }
  };

  const handleConfirmNoItem = async (userID: string) => {
    try {
      const storedBatchID = localStorage.getItem("batchID");
      const storedCheckedItems = localStorage.getItem("skuData");
      const checkedItems = storedCheckedItems ? JSON.parse(storedCheckedItems) : [];
      const confirmResponse = await POST(CHECKER_CONFIRM_NO_ITEM, {
        user_admin_id: userID,
        batch_id: storedBatchID,
        item: checkedItems.map((item: { sku: string; qty: number; total_qty: number }) => ({
          sku: item.sku,
          qty: item.qty,
          total_qty: item.total_qty,
        })),
      });

      if (
        confirmResponse.message === "Batch status updated successfully" &&
        confirmResponse.message !== "invalid input"
      ) {
        setConfirmNoItem(true);
        localStorage.setItem("isConfirmNoItem", "true");
        setIsNoItemModalVisible(false);
      } else {
        notification.error({
          message: "ไม่สำเร็จ!",
          description: "กรุณาติดต่อ admin",
          duration: 4.5,
        });
      }
    } catch (error) {
      console.error("Error calling CHECKER_CONFIRM_NO_ITEM API:", error);
      notification.error({
        message: "ผิดพลาด!",
        description: "การยืนยันไม่มีสินค้าไม่เสร็จสมบูรณ์.",
        duration: 4.5, // ระยะเวลาที่แจ้งเตือนจะแสดง (เป็นวินาที)
      });
    }
  };

  const handleSubmit = async () => {
    setIsloadingSubmit(true);
    try {
      const storedBatchID = localStorage.getItem("batchID");
      const storedCheckedItems = localStorage.getItem("skuData");
      const checkedItems = storedCheckedItems ? JSON.parse(storedCheckedItems) : [];
      const hasCheckedItems = checkedItems.some((item: { isChecked: any }) => item.isChecked);
      const summaryStatus = hasCheckedItems ? 1 : 0;
      await POST(CHECKER_CONFIRM_PICK, {
        batch_id: storedBatchID,
        picker_id: user.user_id,
        summary_status: summaryStatus,
        item: checkedItems.map((item: { sku: any; qty: any; total_qty: any }) => ({
          sku: item.sku,
          qty: item.qty,
          total_qty: item.total_qty,
        })),
      });

      localStorage.removeItem("batchID");
      localStorage.removeItem("skuData");
      localStorage.removeItem("skuQuantities");
      localStorage.removeItem("isConfirmNoItem");
      notification.success({
        message: "สำเร็จ!",
        description: "การยืนยันการเลือกสินค้าเสร็จสมบูรณ์.",
        duration: 2,
        onClose: () => {
          window.location.reload();
        },
      });
    } catch (error) {
      console.error("Error locking the batch:", error);
      notification.error({
        message: "ผิดพลาด!",
        description: "การยืนยันการเลือกสินค้าไม่เสร็จสมบูรณ์.",
        duration: 4.5,
      });
    } finally {
      await handleGetStat();
      setIsloadingSubmit(false);
    }
  };

  // Logic to determine if the Submit button should be displayed
  const isShowButton = data.every((item) => item.isFull || item.isChecked) && data.length > 0;
  const isShowSubmit = data.every((item) => item.isFull) || isConfirmNoItem;

  return (
    <LoginedLayout>
      <ContentBox>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "16px",
            borderBottom: "1px solid #e8e8e8",
            paddingBottom: "8px",
          }}
        >
          <h2 style={{ marginBottom: "8px" }}>Pick Page</h2>
          <Space>
            <Switch
              checked={isSwitchOn}
              onChange={setIsSwitchOn}
              checkedChildren="On"
              unCheckedChildren="Off"
              disabled={isShowButton} // when button display
            />
            <div className={isSwitchOn ? "fade-in" : "fade-out"}>
              {isSwitchOn && (
                <Popconfirm
                  title="Are you sure to reset the data?"
                  onConfirm={handleReset}
                  okText="Yes"
                  cancelText="No"
                  disabled={isShowButton}
                >
                  <Button
                    disabled={isShowButton} // when button display
                  >
                    Reset
                  </Button>
                </Popconfirm>
              )}
            </div>
          </Space>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <Statistic
            title={<div style={{ textAlign: "center", fontSize: 13 }}>Order Target</div>}
            value={totalOrder}
            suffix={`/ ${targetOrder} Order`}
            valueStyle={{
              fontWeight: 700,
              fontSize: 18,
              textAlign: "center",
              lineHeight: "1.2",
              color: isAchieved ? "#52c41a" : "#ff4d4f",
            }}
            style={{
              width: "100%",
              maxWidth: 240,
              margin: "6px",
              padding: "8px",
              border: `1.5px solid ${isAchieved ? "#52c41a" : "#ff4d4f"}`,
              borderRadius: 8,
              boxShadow: `0px 4px 10px ${isAchieved ? "#52c41a" : "#ff4d4f"}`,
            }}
          />
          <Statistic
            title={<div style={{ textAlign: "center", fontSize: 13 }}>Avg. Time</div>}
            value={averageTime}
            suffix={` / ${targetAverageTime} Sec.`}
            valueStyle={{
              fontWeight: 700,
              fontSize: 18,
              textAlign: "center",
              lineHeight: "1.2",
              color: isTimeGood ? "#52c41a" : "#ff4d4f",
            }}
            style={{
              width: "100%",
              maxWidth: 240,
              margin: "6px",
              padding: "8px",
              border: `1.5px solid ${isTimeGood ? "#52c41a" : "#ff4d4f"}`,
              borderRadius: 8,
              boxShadow: `0px 4px 10px ${isTimeGood ? "#52c41a" : "#ff4d4f"}`,
            }}
          />
        </div>
        <ContentBox>
          <Row gutter={[16, 8]} justify="center" style={{ marginBottom: "16px" }}>
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label>Batch NO:</label>
            </Col>
            <Col xs={24} sm={18} lg={10} xl={12}>
              <Input
                value={batchID}
                onChange={(e) => setBatchID(e.target.value)}
                placeholder="กรุณาใส่เลข Batch"
                onPressEnter={(e: any) => handleBatchEntered(e.target.value)}
                style={{ width: "100%" }}
                disabled={batchNoScanned || (isShowButton && isShowSubmit) || isloading}
                autoFocus={!batchNoScanned}
              />
            </Col>
          </Row>
          <Row gutter={[16, 8]} justify="center" style={{ marginBottom: "16px" }}>
            <Col xs={24} sm={12} lg={8} xl={6}>
              <label>Sku:</label>
            </Col>
            <Col xs={24} sm={18} lg={10} xl={12}>
              <Input
                value={skuID}
                onChange={(e) => setSKU(e.target.value)}
                placeholder="กรุณาใส่เลข SKU"
                onPressEnter={(e: any) => handleSKUInputChange(e.target.value)}
                style={{ width: "100%" }}
                disabled={!batchID || (isShowButton && isShowSubmit)}
                ref={skuInputRef}
                maxLength={30}
                showCount={{ formatter: ({ count, maxLength }) => `${count}/${maxLength}` }}
              />
            </Col>
          </Row>
        </ContentBox>
        {isloading ? (
          <Skeleton active />
        ) : (
          <Table
            columns={columns}
            dataSource={data}
            rowKey={rowKey}
            pagination={false}
            rowClassName={(record) => {
              if (record.isFull && !record.isChecked) {
                return "green-row";
              } else if (record.isChecked) {
                return "blue-row";
              } else if (record.qty < record.total_qty && record.qty !== 0) {
                return "yellow-row";
              } else {
                return "red-row";
              }
            }}
          />
        )}
        {isShowButton && !isShowSubmit && (
          <Button
            type="primary"
            size="large"
            loading={isloadingNoItem}
            style={{
              background: "orange",
              marginTop: "20px",
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
              width: "100%",
              maxWidth: "150px",
            }}
            onClick={handleNoItem}
          >
            Waiting
          </Button>
        )}
        {isShowButton && isShowSubmit && (
          <Button
            type="primary"
            size="large"
            loading={isloadingSubmit}
            style={{
              background: "green",
              marginTop: "20px",
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
              width: "100%",
              maxWidth: "150px",
            }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        )}
        {isWarningModalVisible && (
          <WarningModal
            onClose={() => setIsWarningModalVisible(false)}
            visible={isWarningModalVisible} // Pass the 'visible' prop
          />
        )}
        {isOtpModalVisible && (
          <OtpModal
            visible={isOtpModalVisible}
            onOtpSubmit={handleOtpSubmit} // ส่งฟังก์ชันที่จะตรวจสอบ OTP ที่ผู้ใช้ใส่
            incorrectOTP={false} // ตั้งค่าให้เป็น false เนื่องจากรหัส OTP ถูกต้องที่ได้รับจาก API
          />
        )}
        {isnoItemModalVisible && (
          <NoItemModal visible={isnoItemModalVisible} onConfirm={handleConfirmNoItem} />
        )}
        {isWarningModalVisible && (
          <WarningModal
            onClose={() => setIsWarningModalVisible(false)}
            visible={isWarningModalVisible}
          />
        )}
      </ContentBox>
    </LoginedLayout>
  );
};

export default PickFocus;
